import { render, staticRenderFns } from "./Withdraw.vue?vue&type=template&id=0871c3a0&scoped=true&"
import script from "./Withdraw.vue?vue&type=script&lang=js&"
export * from "./Withdraw.vue?vue&type=script&lang=js&"
import style0 from "./Withdraw.vue?vue&type=style&index=0&id=0871c3a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871c3a0",
  null
  
)

export default component.exports